// extracted by mini-css-extract-plugin
export default {"container":"statHeader_container__6CuAQ","rightSpan":"statHeader_rightSpan__SnpyU","image":"statHeader_image__gNGXH"};